<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/ground-regulations">About Us</a></li>
                            <li><a routerLink="/club/premier-outdoor-venue" >Uptonsteel County Ground</a></li>
                            <li><a routerLink="/recruitment" class="active">Recruitment</a></li>
                            <li><a routerLink="/contact" > Contact Us</a></li>                                                          
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <div class="club-hero-section cf">
        <div class="container">
            <div class="club-fischer-section cf" *ngIf="recruitmentList?.data?.length > 0">
                <div class="club-fischer-detail" *ngFor="let recruitment of recruitmentList?.data">
                    <div class="club-fischer-image">
                        <img [src]="recruitment?.image">
                    </div>
                    <div class="club-fischer-content">
                        <div class="titel-box">
                            <h2 class="titel-name">{{recruitment?.title}}</h2>
                        </div>
                        <div class="club-fischer-text" [innerHTML]="recruitment?.description">
                            
                        </div>
                        <div class="club-fischer-btn" *ngFor="let button of recruitment?.club_recruitment_pdf">
                            <a href="{{button?.pdf}}" download *ngIf="button?.pdf">{{button?.title}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->